import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import AllCourses from '../CoursesDetailePage/AllCourses';
import { Route, Routes } from 'react-router-dom';

function Navbars() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-white shadow fixed-top w-100">
      <div className="container">
        <a className="navbar-brand text-primary" href="#">DroneShala</a>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded={isOpen} aria-label="Toggle navigation" onClick={() => setIsOpen(!isOpen)}>
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className={`collapse navbar-collapse ${isOpen ? 'show' : ''}`} id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <a className="nav-link text-dark" href="#">Home</a>
            </li>
            <li className="nav-item">
            <a className="nav-link text-dark" href="training-courses/0">Courses</a>
            </li>
            <Routes>
          <Route path="training-courses/0" element={<AllCourses />} />
          {/* Other routes */}
        </Routes>
            <li className="nav-item">
              <a className="nav-link text-dark" href="#">Community</a>
            </li>
            <li className="nav-item">
              <a className="nav-link text-dark" href="#">E-Library</a>
            </li>
            <li className="nav-item">
              <button className="btn btn-primary">Sign Up</button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbars;
